import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useAxiosFetch from "../common/useAxiosFetch";
import LoadPage from "../common/LoadPage";
import { updateDb } from "../services/updateDb";
import { useAppContext } from "../AppContext";
import { Pill } from "./mailingUi";

const SOURCE_TONES = { link: 'blue', 'one-click': 'blue', superadmin: 'gray' };

const UnsubscribesTab = () => {
  const { t } = useTranslation();
  const { showAlertMessage } = useAppContext();
  const { data, loading, refetch } = useAxiosFetch('/api/mailings/unsubscribes');
  const [email, setEmail] = useState('');
  const [search, setSearch] = useState('');
  const [adding, setAdding] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState(null);
  const [removing, setRemoving] = useState(false);

  const add = async (e) => {
    e.preventDefault();
    setAdding(true);
    const res = await updateDb('/api/mailings/unsubscribes', { email: email.trim() });
    setAdding(false);
    if (res.success) {
      setEmail('');
      refetch();
      showAlertMessage('success', t('mailing.unsubscribe_added'));
    } else {
      showAlertMessage('error', res.error || t('mailing.error'));
    }
  };

  const remove = async () => {
    const address = confirmEmail;
    setRemoving(true);
    const res = await updateDb(`/api/mailings/unsubscribes?email=${encodeURIComponent(address)}`, {}, 'delete');
    setRemoving(false);
    setConfirmEmail(null);
    if (res.success) {
      refetch();
      showAlertMessage('success', t('mailing.resubscribed', { email: address }));
    } else {
      showAlertMessage('error', res.error || t('mailing.error'));
    }
  };

  if (loading && !data) return <LoadPage />;

  const visible = (data || []).filter((item) => !search || item.email.includes(search.toLowerCase()));

  return (
    <>
      <Modal show={Boolean(confirmEmail)} onHide={() => setConfirmEmail(null)}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>{t('mailing.resubscribe_title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('mailing.resubscribe_confirm', { email: confirmEmail })}</Modal.Body>
        <Modal.Footer>
          <div className="white-border-btn cancel-btn" onClick={() => setConfirmEmail(null)}>{t('cancel')}</div>
          <div style={{ flexGrow: 1 }} />
          <button type="button" className="white-border-btn submit-btn" disabled={removing} onClick={remove}>
            <i className="icon-undo" /> {t('mailing.resubscribe')}
          </button>
        </Modal.Footer>
      </Modal>

      <p className="mail-section-sub" style={{ marginBottom: 20, maxWidth: 760 }}>{t('mailing.unsubscribes_intro')}</p>

      <div className="mail-toolbar">
        <form onSubmit={add} className="mail-toolbar" style={{ margin: 0, flexWrap: 'nowrap' }}>
          <input type="email" required className="form-control" style={{ width: 280 }} placeholder={t('mailing.email_to_unsubscribe')} value={email} onChange={(e) => setEmail(e.target.value)} aria-label={t('mailing.email_to_unsubscribe')} />
          <button type="submit" className="rq-btn rq-btn-primary" disabled={adding}>{t('mailing.add_unsubscribe')}</button>
        </form>
        <div className="mail-toolbar-spacer" />
        <div className="mail-search">
          <i className="icon-search" />
          <input type="search" className="form-control" placeholder={t('mailing.search_email')} value={search} onChange={(e) => setSearch(e.target.value)} aria-label={t('mailing.search_email')} />
        </div>
      </div>

      <div className="mail-table-wrap">
        <table className="mail-table">
          <thead>
            <tr>
              <td>{t('mailing.email')}</td>
              <td>{t('mailing.date')}</td>
              <td>{t('mailing.source')}</td>
              <td />
            </tr>
          </thead>
          <tbody>
            {visible.map((item) => (
              <tr key={item.id}>
                <td><strong>{item.email}</strong></td>
                <td className="nowrap">{`${moment(item.createdAt).format('ll')} ${moment(item.createdAt).format('HH:mm')}`}</td>
                <td><Pill tone={SOURCE_TONES[item.source] || 'gray'} plain>{t(`mailing.source_${item.source}`)}</Pill></td>
                <td style={{ textAlign: 'right' }}>
                  <button type="button" className="mail-link-btn" onClick={() => setConfirmEmail(item.email)}>
                    <i className="icon-undo" /> {t('mailing.resubscribe')}
                  </button>
                </td>
              </tr>
            ))}
            {visible.length === 0 && (
              <tr className="mail-empty-row"><td colSpan={4}>{t('mailing.no_unsubscribes')}</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default UnsubscribesTab;
